import React from 'react';
import { Modal as AntModal, Drawer as AntDrawer } from 'antd';
import type { ModalProps, DrawerProps } from 'antd';
import { DevModalFilePath } from './DevModalFilePath';

type ModalComponent = typeof AntModal;
type DrawerComponent = typeof AntDrawer;

/**
 * Modalコンポーネントにファイルパス表示を追加するラッパー
 */
export function withDevModalFilePath(
  filePath: string
): {
  Modal: ModalComponent;
  Drawer: DrawerComponent;
} {
  const DevModal = Object.assign(
    (props: ModalProps) => {
      if (import.meta.env.PROD) {
        return <AntModal {...props} />;
      }

      const enhancedTitle = (
        <span>
          {props.title}
          <DevModalFilePath
            filePath={filePath}
            modalTitle={String(props.title ?? '')}
          />
        </span>
      );

      return <AntModal {...props} title={enhancedTitle} />;
    },
    AntModal
  ) as ModalComponent;

  const DevDrawer = Object.assign(
    (props: DrawerProps) => {
      if (import.meta.env.PROD) {
        return <AntDrawer {...props} />;
      }

      const enhancedTitle = (
        <span>
          {props.title}
          <DevModalFilePath
            filePath={filePath}
            modalTitle={String(props.title ?? '')}
          />
        </span>
      );

      return <AntDrawer {...props} title={enhancedTitle} />;
    },
    AntDrawer
  ) as DrawerComponent;

  return {
    Modal: DevModal,
    Drawer: DevDrawer,
  };
}
